import { Component, Input, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { loadRemoteModule } from '@angular-architects/module-federation';
import { CartridgeWidget } from '../../../models/dashboard.models';
import { WebComponentWrapperOptions } from '@angular-architects/module-federation-tools';

@Component({
  selector: 'markant-platform-cartridge-widget',
  templateUrl: './cartridge-widget.component.html',
})
export class CartridgeWidgetComponent implements OnInit {
  @ViewChild('placeholder', { read: ViewContainerRef, static: true })
  viewContainer!: ViewContainerRef;

  @Input() widget!: CartridgeWidget;
  @Input() dragActive = false;

  error = false;
  widgetOptions = {
    type: 'module',
  } as WebComponentWrapperOptions;

  async ngOnInit(): Promise<void> {
    const componentName = this.widget.componentName;

    if (!componentName && !this.widget.elementName) {
      return;
    }

    if (componentName) {
      // Remove placeholder content
      this.viewContainer.clear();

      // Load remote modules asynchronously
      const component: Type<Component> = await loadRemoteModule({
        type: 'module',
        remoteEntry: this.widget.remoteEntry,
        exposedModule: this.widget.exposedModule,
      })
        .then(m => {
          if (!m[componentName]) {
            throw new Error(`[${componentName}] Component definition not found in module`);
          }
          return m[componentName];
        })
        .catch(e => {
          this.error = true;
          throw e;
        });

      // If successful, create component instance in placeholder
      if (component) {
        this.viewContainer.createComponent(component);
        this.widgetOptions = this.getWebComponentOptions(this.widget);
      }
    }
  }

  private getWebComponentOptions(widget: CartridgeWidget): WebComponentWrapperOptions {
    return {
      type: 'module',
      remoteEntry: widget.remoteEntry,
      exposedModule: widget.exposedModule,
      elementName: widget.elementName as string,
    };
  }
}
